/** API route map: URLS.Controller.ManageTeams */
export const ManageTeams = {
      Name: 'ManageTeam/',
      AddTeam: 'add-team',
      GetTeamMember: 'get-team-member/',
      GetTeamMemberPaginated: 'get-team-member-paginated',
      GetTeam: 'get-team',
      DeleteTeamMember: 'delete-team-member/',
      DeleteTeam: 'delete-team/',
      DeleteAllMember: 'delete-all-members',
      GetTeamById: 'get-team-name/',
      UpdateMemberRole: 'update-member-role',
      UpdateTeam: 'update-team',
      editTeam: 'edit-team',
};
